import React from 'react';
import ProfileEdit from './ProfileEdit';
/**
 * Reference와 동일한 구조의 ProfileEditPage 래퍼
 * 
 * ProfileEdit 컴포넌트를 래핑하여 페이지 형태로 제공합니다.
 */ var ProfileEditPage = function(props) {
    return /*#__PURE__*/ React.createElement(ProfileEdit, props);
};
export default ProfileEditPage;
